export interface ReferralState {
    code: string,
    reward: number,
}

export const initialReferralState: ReferralState = {
    code: '',
    reward: 0,
};